//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/devices/views/main/lan/es';
import overview from 'Modules/devices/views/overview/lan/es';
import devicesTab from 'Modules/devices/.components/tab/lan/es';
import vidFleetVideo from 'Modules/devices/.components/vidFleetVideo/lan/es';
import bulkPairing from 'Modules/devices/.components/bulkPairing/lan/es';
import bulkActions from 'Modules/devices/.components/bulkActions/lan/es';
import activateSimCard from 'Modules/devices/.components/activateSimCard/lan/es';
import changeSimProvider from 'Modules/devices/.components/changeSimProvider/lan/es';
import importDevices from 'Modules/devices/.components/importDevices/lan/es';
import bulkUnparing from 'Modules/devices/.components/bulkUnpairing/lan/es';
import assignFirmware from 'Modules/devices/.components/assignFirmware/lan/es';
import pulsInfo from 'Modules/devices/.components/pulsInfoTab/lan/es';
import simInfo from 'Modules/devices/.components/simInfoTab/lan/es';
import features from 'Modules/devices/.components/featureTab/lan/es';
import troubleShootingEventsTab from 'Modules/devices/.components/troubleShootingEventsTab/lan/es';
import formatSDCard from 'Modules/devices/.components/formatSDCard/lan/es';
import rebootDevice from 'Modules/devices/.components/rebootDevice/lan/es';
import requestDeviceLog from 'Modules/devices/.components/requestDeviceLog/lan/es';
import messagesOutboxTab from 'Modules/devices/.components/messagesOutboxTab/lan/es';
import editSwapSimCard from 'Modules/devices/.components/editSwapSimCard/lan/es';
import sendCommands from 'Modules/devices/.components/sendCommand/lan/es';
import changePulsCustomer from 'Modules/devices/.components/changePulsCustomer/lan/es';
import changeScript from 'Modules/devices/.components/changeScript/lan/es';
import changeStatus from 'Modules/devices/.components/changeStatus/lan/es';
import moveToOtherAccount from 'Modules/devices/.components/moveToOtherAccount/lan/es';
import markAsRma from 'Modules/devices/.components/markAsRma/lan/es';
import refurbishDevice from 'Modules/devices/.components/refurbishDevice/lan/es';
import associateToGps from 'Modules/devices/views/overview/.components/associateToGps/lan/es';
import notes from 'Modules/devices/.components/notesTab/lan/es';
import createEditNote from 'Modules/devices/.components/notesTab/.components/createEditNote/lan/es';
import deleteNote from 'Modules/devices/.components/notesTab/.components/deleteNote/lan/es';
import revertRma from 'Modules/devices/.components/revertRma/lan/es';
import changeTimezone from 'Modules/devices/.components/changeTimezone/lan/es';
import maintenanceWarnings from 'Modules/devices/.components/maintenanceWarnings/lan/es';
import dailyDeviceAudit from 'Modules/devices/.components/dailyDeviceAudit/lan/es';
import coverageDetails from 'Modules/devices/.components/coverageDetails/lan/es';
import createDiagnosticDevice from 'Modules/devices/.components/createDiagnosticDevice/lan/es';
import userTroubleshooting from 'Modules/devices/.components/userTroubleshooting/lan/es';
import clipRequestTab from 'Modules/devices/.components/clipRequestTab/lan/es';
import createClipRequest from 'Modules/devices/.components/createClipRequest/lan/es';
import deleteClipRequest from 'Modules/devices/.components/deleteClipRequest/lan/es';
import castImportManual from 'Modules/devices/.components/castImportManual/lan/es';

locales = { 
    ...locales, 
    ...main, 
    ...overview, 
    ...devicesTab, 
    ...vidFleetVideo,
    ...bulkPairing,
    ...bulkActions,
    ...activateSimCard,
    ...changeSimProvider,
    ...importDevices,
    ...bulkUnparing,
    ...assignFirmware,
    ...pulsInfo,
    ...simInfo,
    ...features,
    ...troubleShootingEventsTab,
    ...formatSDCard,
    ...rebootDevice,
    ...requestDeviceLog,
    ...messagesOutboxTab,
    ...editSwapSimCard,
    ...sendCommands,
    ...changePulsCustomer,
    ...changeScript,
    ...changeStatus,
    ...moveToOtherAccount,
    ...markAsRma,
    ...refurbishDevice,
    ...associateToGps,
    ...notes,
    ...createEditNote,
    ...deleteNote,
    ...revertRma,
    ...changeTimezone,
    ...maintenanceWarnings,
    ...dailyDeviceAudit,
    ...coverageDetails,
    ...createDiagnosticDevice,
    ...userTroubleshooting,
    ...clipRequestTab,
    ...createClipRequest,
    ...deleteClipRequest,
    ...castImportManual,
};


export default locales;